"use client"

import {
  UserIcon,
  ListBulletIcon,
  EnvelopeIcon,
  Cog6ToothIcon,
  BellIcon,
  QuestionMarkCircleIcon,
  ChatBubbleLeftIcon,
  ArrowUpRightIcon,
} from "@heroicons/react/24/outline"
import Link from "next/link"
import React, { useState } from "react"
import { LogoutButton } from "./logoutButton"
import { Session } from "next-auth"
import clsx from "clsx"
import { DiscordLogoIcon, QuestionMarkCircledIcon } from "@radix-ui/react-icons"
import { Dialog, DialogActions, DialogBody, DialogDescription, DialogTitle } from "../catalyst/dialog"
import { FeedbackForm } from "./feedbackForm"

type Props = {
  session: Session | null
  className?: string
}

export const NotificationInfoDropdown: React.FC<Props> = ({ session, className }) => {
  const avatarImage = session?.user?.image || session?.user?.picture
  const initials = session?.user?.name ? session.user.name.match(/\b(\w)/g)?.join("") : ""
  let [isOpen, setIsOpen] = useState(false)
  return (
    <>
      {/* <LogoutButton /> */}
      <div className="ml-4 dropdown dropdown-end">
        <button
          tabIndex={0}
          type="button"
          className="relative ml-2 flex-shrink-0 rounded-full bg-white p-1 text-gray-500 hover:text-gray-500 focus:outline-none "
        >
          {/* <div className="w-10 rounded-full"> */}
          <span className="absolute -inset-1.5" />
          <span className="sr-only">View notifications</span>
          {/* <QuestionMarkCircleIcon className="h-6 w-6" aria-hidden="true" /> */}
          <QuestionMarkCircledIcon className="h-6 w-6" aria-hidden="true" />
          {/* </div> */}
        </button>
        <ul
          tabIndex={0}
          className="p-2 mt-3 w-52 shadow menu menu-compact dropdown-content bg-base-100 rounded-box z-10"
        >
          <li>
            <Link href="/docs" target="_blank">
              Documentation
              <ArrowUpRightIcon className="inline-block pl-1 w-5 text-gray-600" />
            </Link>
          </li>
          <li>
            <Link href="/" target="_blank">
              Website <ArrowUpRightIcon className="inline-block pl-1 w-5 text-gray-600" />
            </Link>
          </li>
          <li>
            <Link href="https://discord.gg/HwB5J3XgQG" target="_blank">
              {/* <DiscordLogoIcon className="w-4 text-gray-600" /> */}
              Discord community <ArrowUpRightIcon className="inline-block pl-1 w-5 text-gray-600" />
            </Link>
          </li>
          <li>
            <div onClick={() => setIsOpen(true)}>
              Leave feedback
              <ChatBubbleLeftIcon className="inline-block pl-1 w-5 text-gray-600" />
            </div>
          </li>
          {/* <li>
            <Link href="/app/settings">
              <Cog6ToothIcon className="w-4 text-gray-600" />
              Settings
            </Link>
          </li> */}
          {/* <li className="border-t mt-2 pt-2">
            <LogoutButton />
          </li> */}
        </ul>
      </div>
      <Dialog open={isOpen} onClose={setIsOpen}>
        <DialogTitle>Share feedback</DialogTitle>
        <DialogDescription>
          We would love to hear your feedback. Please share your thoughts, ideas, and suggestions with us.
        </DialogDescription>
        <DialogBody>
          <FeedbackForm />
        </DialogBody>
      </Dialog>
    </>
  )
}
